import filtroReducer from './filtro'
import { combineReducers } from 'redux'

export const Reducers = combineReducers({
  filtroReducer,
})
